import { app } from "../Frame/App";
import { IAppComponent } from "../Frame/IAppComponent";

export class LeftMenu implements IAppComponent {
    static instance: LeftMenu;

    /**
     * Initialize menues.
     */
    public initialize(): void {

        let menues = document.getElementsByClassName("leftmenu-frame");
        for (let i = 0; i < menues.length; i++) {
            this.initMenu((menues[i] as HTMLElement));
        }
    }

    /**
     * Initialize a single menu.
     * @param menu Menu to initialize.
     */
    private initMenu(menu: HTMLElement) {
        // check for url query
        let page = app.getParameterByName("page");
        let clickDone: boolean = false;

        let clearUpdatePanelOnClick = true;
        if (menu.hasAttribute("data-clear-update-panel-on-click"))
            clearUpdatePanelOnClick = menu.getAttribute("data-clear-update-panel-on-click") == "true";

        let rows = menu.getElementsByTagName("a");
        for (let i = 0; i < rows.length; i++) {
            let item = (rows[i] as HTMLElement);
            item.addEventListener("click", () => {
                this.setActive(menu, item);
                if (clearUpdatePanelOnClick) {
                    this.clearUpdatePanel(item);
                }
                return true;
            });

            if (page && page.length > 0 && item.getAttribute("data-page") == page) {
                (item as HTMLAnchorElement).click();
                clickDone = true;
            }
        }



        // click on active tab
        if (!clickDone) {
            for (let i = 0; i < rows.length; i++) {
                let item = (rows[i] as HTMLElement);

                if (item.classList.contains("active")) {
                    let collapseParents = $(item).parents(".collapse");
                    for (let j = collapseParents.length - 1; j >= 0; j--)
                        $(collapseParents[j]).collapse("show");

                    (item as HTMLAnchorElement).click();
                }
            }
        }
    }

    /**
     * Change active menu item
     * @param menu
     * @param activeItem
     */
    private setActive(menu: HTMLElement, activeItem: HTMLElement) {
        let rows = menu.getElementsByTagName("a");
        for (let i = 0; i < rows.length; i++) {
            let item = (rows[i] as HTMLElement);
            item.classList.remove("active");
        }
        activeItem.classList.add("active");
    }

    /**
     * Remove all content from update panel
     * @param item
     */
    clearUpdatePanel(item: HTMLElement) {
        let id = item.getAttribute("data-ajax-update");
        if (id) {
            let panel = document.getElementById(id.substring(1));
            panel.innerHTML = "";
        }
    }

    /**
     * Refresh the content of active menu item 
     * @param menu 
     */
    public refreshActive(menu: HTMLElement) {
        let menuElement = menu;
        let rows = menuElement.getElementsByTagName("a");
        for (let i = 0; i < rows.length; i++) {
            let item = (rows[i] as HTMLElement);
            if (item.classList.contains("active")) {
                $(item).click();
            }
        }
    }
}


